export const DYNAMIC_EXPRESS_CHECKOUT = {
  url: 'https://expresscheckout.cdn.orders.vpsvc.com/v6',
  scope: 'ExpressCheckout',
  module: './ExpressCheckoutComponent',
  fileName: 'expressCheckout.js',
};

export const DYNAMIC_TENANT_DETAILS = {
  url: 'https://expresscheckout.cdn.orders.vpsvc.com/v6',
  scope: 'ExpressCheckout',
  module: './getCartTenantDetailsUtil',
  fileName: 'expressCheckout.js',
};
